import ProductCSP from "../../models/csp/ProductCSP";
import service from "../service";
import baseEndpointCSP from "./serviceCSP";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  methods: {
    getProducts: async function (type: string) {
      const endpoint = `${baseEndpointPartnerCenter}/products?country=es&targetView=${type}`;
      const response = await service.methods.getEndpointAsync(endpoint);
      return response.items.map(
        i =>
          new ProductCSP({
            id: i.id,
            title: i.title,
            skusLink: i.links.skus.uri,
            skusList: [],
            productType: i.productType.id
          })
      );
    },
    getProductSkus: async function (product) {
      const endpoint =
        baseEndpointPartnerCenter + `/products/${product}/skus?country=es`;
      const response = await service.methods.getEndpointAsync(endpoint);
      return response.items.map(i => ({
        id: i.id,
        productId: i.productId,
        title: i.title,
        description: i.description,
        minimumQuantity: i.minimumQuantity,
        maximumQuantity: i.maximumQuantity,
        catalogItemId: null
      }));
    },
    getProductAvailabilities: async function (productId, skuId) {
      const endpoint =
        baseEndpointPartnerCenter +
        `/products/${productId}/skus/${skuId}/availabilities?country=es`;
      const response = await service.methods.getEndpointAsync(endpoint);
      return {
        catalogItemId: response.items[0].catalogItemId,
        terms: response.items[0].terms.map(t => ({
          duration: t.duration,
          billingCycle: t.billingCycle
        }))
      };
    },
    getProductPrice: async function (productData: {
      productId: string;
      skuId: string;
      billingCycle: string;
      termDuration: string;
    }) {
      const endpoint =
        baseEndpointCSP +
        `/Pricesheet?productId=${productData.productId}&skuId=${productData.skuId}&billingCycle=${productData.billingCycle}&termDuration=${productData.termDuration}`;
      const response = await service.methods.getEndpointAsync(endpoint);
      return response;
    }
  }
};
